export default "__VITE_ASSET__BVNsUK3B__"